"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("@powerednow/shared/constants");
const bluebird_1 = __importDefault(require("bluebird"));
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const customerEmailTemplateValues_1 = __importDefault(require("@powerednow/shared/constants/customerEmailTemplateValues"));
const date_1 = require("@powerednow/shared/modules/utilities/date");
const errors_1 = require("@powerednow/errors");
const modelLookup_1 = require("../modelLookup");
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
const templateDataExtender_1 = __importDefault(require("../../utilities/templateDataExtender"));
// eslint-disable-next-line no-redeclare
class CustomerMessage extends complexData_1.default {
    static get allowedAssociations() {
        return {
            company: {
                key: 'company',
                instance: (0, modelLookup_1.complexFindModel)('Company'),
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().company_id,
                },
            },
            user: {
                key: 'user',
                instance: (0, modelLookup_1.complexFindModel)('User'),
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().user_id,
                },
            },
            messageRecipient: {
                key: 'messageRecipient',
                instance: (0, modelLookup_1.complexFindModel)('MessageRecipient'),
                condition: {
                    message_id: this.Entity.getForeignFieldSymbols().id,
                },
            },
            customerMessageAttachment: {
                key: 'customerMessageAttachment',
                instance: (0, modelLookup_1.complexFindModel)('CustomerMessageAttachment'),
                condition: {
                    customermessage_id: this.Entity.getForeignFieldSymbols().id,
                },
            },
            children: {
                key: 'customerMessage',
                instance: (0, modelLookup_1.complexFindModel)('CustomerMessage'),
                condition: {
                    parent_id: this.Entity.getFieldSymbols().id,
                },
            },
            parent: {
                key: 'customerMessage',
                instance: (0, modelLookup_1.complexFindModel)('CustomerMessage'),
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().parent_id,
                },
            },
            action: {
                key: 'action',
                instance: (0, modelLookup_1.complexFindModel)('Action'),
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().linked_id,
                    [this.Entity.getFieldSymbols().linked_type]: constants_1.MESSAGES.CUSTOMER_MESSAGE_LINK_TYPES.APPOINTMENT,
                },
            },
            document: {
                key: 'document',
                instance: (0, modelLookup_1.complexFindModel)('Document'),
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().linked_id,
                    [this.Entity.getFieldSymbols().linked_type]: constants_1.MESSAGES.CUSTOMER_MESSAGE_LINK_TYPES.DOCUMENT,
                },
            },
            formDocument: {
                key: 'formDocument',
                instance: (0, modelLookup_1.complexFindModel)('FormDocument'),
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().linked_id,
                    [this.Entity.getFieldSymbols().linked_type]: constants_1.MESSAGES.CUSTOMER_MESSAGE_LINK_TYPES.FORMDOCUMENT,
                },
            },
            payment: {
                key: 'payment',
                instance: (0, modelLookup_1.complexFindModel)('Payment'),
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().linked_id,
                    [this.Entity.getFieldSymbols().linked_type]: constants_1.MESSAGES.CUSTOMER_MESSAGE_LINK_TYPES.PAYMENT,
                },
            },
            job: {
                key: 'job',
                instance: (0, modelLookup_1.complexFindModel)('Job'),
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().job_id,
                },
            },
        };
    }
    getLinkedTypeFromLinkRecord(recordToSend) {
        return {
            Document: constants_1.MESSAGES.CUSTOMER_MESSAGE_LINK_TYPES.DOCUMENT,
            Action: constants_1.MESSAGES.CUSTOMER_MESSAGE_LINK_TYPES.APPOINTMENT,
            Payment: constants_1.MESSAGES.CUSTOMER_MESSAGE_LINK_TYPES.PAYMENT,
            FormDocument: constants_1.MESSAGES.CUSTOMER_MESSAGE_LINK_TYPES.FORMDOCUMENT,
        }[recordToSend.constructor.getModelName()];
    }
    static async getTimelineRecipients(source) {
        return bluebird_1.default.map(await this.getCustomerMessageRecipients(source), async (customerMessageRecipient) => {
            const displayDate = customerMessageRecipient.data.dt_sent;
            return {
                date: (0, date_1.isValid)(displayDate) ? (0, date_1.format)((0, date_1.convertToLocalFromDateString)(displayDate), 'DD/MM/YY HH:mm:ss') : 'N/A',
                email: customerMessageRecipient.data.recipient,
                opens: customerMessageRecipient.data.opens || 0,
                msg_error_message: customerMessageRecipient.data.msg_error_message && new TextEncoder().encode(customerMessageRecipient.data.msg_error_message),
            };
        });
    }
    static async getCustomerMessageRecipients(source) {
        const customerMessages = (await source.getAllCustomerMessage()).filter(customerMessage => !customerMessage.data.parent_id);
        return bluebird_1.default.reduce(customerMessages, async (customerMessageRecipients, customerMessage) => {
            const messageRecipients = await customerMessage.getAllMessageRecipient();
            return [
                ...customerMessageRecipients,
                ...messageRecipients,
            ];
        }, []);
    }
    static getMessageTypeFromLinkRecord(recordToSend) {
        return {
            Document: () => ({
                [constants_1.DOCUMENT.TYPES_VALUES.INVOICE]: customerEmailTemplateValues_1.default.INVOICE_TO_CUSTOMER.ID,
                [constants_1.DOCUMENT.TYPES_VALUES.QUOTE]: customerEmailTemplateValues_1.default.QUOTE_TO_CUSTOMER.ID,
                [constants_1.DOCUMENT.TYPES_VALUES.WORKSHEET]: customerEmailTemplateValues_1.default.WORKSHEET_TO_CUSTOMER.ID,
                [constants_1.DOCUMENT.TYPES_VALUES.CREDITNOTE]: customerEmailTemplateValues_1.default.CREDITNOTE_TO_CUSTOMER.ID,
                [constants_1.DOCUMENT.TYPES_VALUES.SIGNATURE]: customerEmailTemplateValues_1.default.SIGNATURE_TO_CUSTOMER.ID,
                [constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE]: customerEmailTemplateValues_1.default.SUPPLIER_INVOICE_TO_CUSTOMER.ID,
                [constants_1.DOCUMENT.TYPES_VALUES.SUPPLIER_INVOICE_CREDIT]: customerEmailTemplateValues_1.default.SUPPLIER_INVOICE_CREDIT_TO_CUSTOMER.ID,
                [constants_1.DOCUMENT.TYPES_VALUES.EXPENSE]: customerEmailTemplateValues_1.default.EXPENSE_TO_CUSTOMER.ID,
                [constants_1.DOCUMENT.TYPES_VALUES.EXPENSE_CREDITNOTE]: customerEmailTemplateValues_1.default.EXPENSE_CREDITNOTE_TO_CUSTOMER.ID,
                [constants_1.DOCUMENT.TYPES_VALUES.PURCHASE_ORDER]: customerEmailTemplateValues_1.default.PURCHASE_ORDER_TO_CUSTOMER.ID,
            }[recordToSend.data.type]),
            Action: () => customerEmailTemplateValues_1.default.APPOINTMENT_CREATED.ID,
            Payment: () => customerEmailTemplateValues_1.default.PAYMENT.ID,
            FormDocument: () => customerEmailTemplateValues_1.default.FORMDOCUMENT_TO_CUSTOMER.ID,
        }[recordToSend.constructor.getModelName()]();
    }
    async initWithLinkedRecord(linkedRecord, type = undefined) {
        const jobId = linkedRecord instanceof (0, modelLookup_1.complexFindModel)('Payment') ? (await linkedRecord.getDocument())?.data?.job_id : linkedRecord.data.job_id;
        const customerId = (await linkedRecord.getCustomer()).data.id;
        this.data.linked_id = linkedRecord.data.id;
        this.data.job_id = jobId;
        this.data.customer_id = customerId;
        this.data.type = type || CustomerMessage.getMessageTypeFromLinkRecord(linkedRecord);
        this.data.linked_type = this.getLinkedTypeFromLinkRecord(linkedRecord);
        this.data.direction = constants_1.MESSAGES.MESSAGE_DIRECTION.OUTGOING;
        this.data.parent_id = 0;
    }
    async addAttachments(attachments) {
        await bluebird_1.default.map(attachments, attachment => this.addCustomerMessageAttachment({
            attachment_id: attachment.data.id,
        }));
        const allAttachements = await this.getAllCustomerMessageAttachment();
        this.data.attachment_count = attachments.length;
        return allAttachements;
    }
    async getAttachments() {
        return bluebird_1.default.map(this.getAllCustomerMessageAttachment(), customerAttachment => customerAttachment.getAttachment());
    }
    async addRecipientFromContactMethod(contactMethod, contactOrUser) {
        return this.addMessageRecipient({
            contact_id: contactOrUser instanceof (0, modelLookup_1.complexFindModel)('Contact') ? contactOrUser.data.id : null,
            user_id: contactOrUser instanceof (0, modelLookup_1.complexFindModel)('User') ? contactOrUser.data.id : null,
            contactmethodtype_id: contactMethod.data.contactmethodtype_id,
            recipient: contactMethod.data.value,
            recipientName: await contactOrUser.getFullName(),
        });
    }
    async getMessageTypeString() {
        const messageDefinition = this.findDefaultValueById();
        return messageDefinition.NAME;
    }
    async getReplyToUser() {
        const user = await this.getUser();
        if (user) {
            return user;
        }
        const company = await this.getCompany();
        return company.getMainUser();
    }
    async addReply(recipientDetails, direction = undefined, customerMessage = new CustomerMessage({}), messageRecipient = new ((0, modelLookup_1.complexFindModel)('MessageRecipient'))({})) {
        let replyDirection = direction;
        if (typeof direction === 'undefined') {
            replyDirection = (this.data.direction === constants_1.MESSAGES.MESSAGE_DIRECTION.INCOMING ? constants_1.MESSAGES.MESSAGE_DIRECTION.OUTGOING : constants_1.MESSAGES.MESSAGE_DIRECTION.INCOMING);
        }
        const { user_id, customer_id, company_id, linked_id, linked_type, job_id, type, } = this.data;
        Object.assign(customerMessage.data, {
            user_id,
            customer_id,
            company_id,
            linked_id,
            linked_type,
            job_id,
            type,
            parent_id: this.data.id,
            direction: replyDirection,
            dt_created: (0, date_1.getNow)(),
        });
        const newMessage = await this.addChildren(customerMessage);
        Object.assign(messageRecipient.data, recipientDetails);
        await newMessage.addMessageRecipient(messageRecipient);
        return {
            customerMessage: newMessage,
            messageRecipient,
        };
    }
    findDefaultValueById() {
        return Object.values(customerEmailTemplateValues_1.default)
            .find(messageValue => messageValue.ID === this.data.type);
    }
    findDefaultContentById() {
        const messageDefault = this.findDefaultValueById();
        if (!messageDefault?.CONTENT) {
            throw Object.assign(new Error('No default values for message type'), {
                details: {
                    type: this.data.type,
                    id: this.data.id,
                },
            });
        }
        return messageDefault.CONTENT;
    }
    async getLinkedItem() {
        const linkedItemGetter = {
            [constants_1.MESSAGES.CUSTOMER_MESSAGE_LINK_TYPES.DOCUMENT]: () => this.getDocument(),
            [constants_1.MESSAGES.CUSTOMER_MESSAGE_LINK_TYPES.APPOINTMENT]: () => this.getAction(),
            [constants_1.MESSAGES.CUSTOMER_MESSAGE_LINK_TYPES.PAYMENT]: () => this.getPayment(),
            [constants_1.MESSAGES.CUSTOMER_MESSAGE_LINK_TYPES.FORMDOCUMENT]: () => this.getFormDocument(),
        }[this.data.linked_type];
        return linkedItemGetter && linkedItemGetter();
    }
    async getPermanentTemplateData(existingTemplateData) {
        //
        // Add anything here you want to be stored in the templatedata field of the MessageRecipient
        // record at the time of sending
        //
        return {
            ...await this.getPermanentLinkedRecordTemplateData(existingTemplateData),
        };
    }
    async getPermanentLinkedRecordTemplateData(existingTemplateData) {
        const linkedRecord = await this.getLinkedItem();
        if (!linkedRecord) {
            return {};
        }
        const linkedRecordTemplateData = await linkedRecord.getPermanentTemplateData();
        return {
            ...linkedRecordTemplateData,
            ...await this.getMessageTypeSpecificPermanentTemplateData(linkedRecord, { ...linkedRecordTemplateData, ...existingTemplateData }),
        };
    }
    async getLinkedRecordTemplateData(existingTemplateData = {}) {
        const linkedItem = await this.getLinkedItem();
        if (!linkedItem) {
            return {};
        }
        const templateData = await linkedItem.getMessageTemplateData(this.data.type);
        return {
            ...templateData,
            ...await this.getMessageTypeSpecificData(linkedItem, { ...templateData, ...existingTemplateData }),
        };
    }
    async getMessageTypeSpecificData(linkedItem, existingTemplateData) {
        const dataCollectors = linkedItem.constructor.MessageTypeSpecificDataCollectors[this.data.type] || [];
        return bluebird_1.default.reduce(dataCollectors, async (data, collector) => ({
            ...data,
            ...await collector.call(linkedItem.constructor, [this.data.type, linkedItem, existingTemplateData]),
        }), {});
    }
    async getMessageTypeSpecificPermanentTemplateData(linkedItem, existingTemplateData) {
        const dataCollectors = linkedItem.constructor.MessageTypeSpecificPermanentDataCollectors[this.data.type] || [];
        return bluebird_1.default.reduce(dataCollectors, async (data, collector) => ({
            ...data,
            ...await collector.call(linkedItem.constructor, [this.data.type, linkedItem, existingTemplateData]),
        }), {});
    }
    async getDisplayRecipient() {
        return this.getRecipientForChannel('EMAIL');
    }
    async getRecipientForChannel(channel) {
        const recipients = await this.getAllMessageRecipient();
        const emailRecipient = recipients.find(recipient => recipient.getChannelType() === channel);
        return emailRecipient || recipients[0];
    }
    async getHistory() {
        const firstMessage = !this.data.parent_id ? this : await this.getParent();
        const childrenMessages = firstMessage ? await firstMessage.getAllChildren() : [];
        childrenMessages.sort((messageA, messageB) => (new Date(messageA.data.dt_created).getTime() - new Date(messageB.data.dt_created).getTime()));
        return [firstMessage, ...childrenMessages];
    }
    async findSite() {
        const job = await this.getJob();
        return job.findSite();
    }
    async getContacts() {
        const recipients = await this.getAllMessageRecipient();
        return bluebird_1.default.map(recipients, recipient => recipient.getContact());
    }
    async getNotificationTemplateData(existingTemplateData = {}) {
        const job = await this.getJob();
        if (!job) {
            throw new errors_1.AppUsabilityError({
                message: `Job not found for message:${this.data.id}. Most likely message deleted.`,
                severity: 2,
            });
        }
        const customer = await job?.getCustomer();
        const company = await this.getCompany();
        const extender = new templateDataExtender_1.default({
            projectName: job?.data.description,
            customerName: await customer?.getFullName(),
            currencyOptions: (await company.getCurrency()).getData().getDataValues(),
        });
        await extender.addLinkedRecordTemplateData(this, existingTemplateData);
        await extender.addLocaleInfoForCompany(company);
        return extender.getData();
    }
}
CustomerMessage.Entity = entity_1.default;
CustomerMessage.modelProperties = modelProperties_1.default;
exports.default = CustomerMessage;
//# sourceMappingURL=../../../../src/models/customerMessage/index.js.map